export class BaseHandler {
    constructor(someArg) {
        this.someArg = someArg;
    }
}
